module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "file_012a"
    }
  }, [_vm._v("Foam")])]), _c('a', {
    attrs: {
      "id": "file_012a"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("You will need to have a piece of foam or sponge to absorb the needle when it penetrates through the wool. The best surface to use for needle felting is high-density foam that is at least 1½″ (3.8 cm) thick. Place the wool on the pad and keep needling without worrying about poking your leg or breaking your needle. Some craft stores sell upholstery foam, which can be used in a pinch, but it breaks down faster than the high-density foam.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34988da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_012a.vue
// module id = 90
// module chunks = 0